export default __webpack_public_path__ + "static/media/home-mobile-banner.b4dfa729.webp";